/**
 * Bètafuncties per bedrijf.
 *
 * Een bètafunctie staat voor elk bedrijf UIT, tot een systeembeheerder hem aanzet (Beheer →
 * Bedrijven). Daarnaast vragen alle bètafuncties hieronder een GeoDesk-licentie: zonder GeoDesk
 * bestaan ze voor een bedrijf niet, ook niet als de schakelaar aan staat.
 *
 * Opgeslagen als JSON-lijst van id's in `companies.beta_features`, bv. `["rapportage"]`.
 */

export type BetaFeature = 'vooronderzoek' | 'rapportage';

export interface BetaFeatureDef {
  id: BetaFeature;
  label: string;
  description: string;
}

export const BETA_FEATURES: readonly BetaFeatureDef[] = [
  {
    id: 'vooronderzoek',
    label: 'Vooronderzoek',
    description: 'De tabbladen Vooronderzoek (monsterplan NEN 5740) en Opdracht (veldwerkopdracht inlezen en toetsen), en de opdracht in de veldapp.',
  },
  {
    id: 'rapportage',
    label: 'Rapportage',
    description: 'Vanuit een project een rapport verkennend bodemonderzoek opstellen, als Word-bestand.',
  },
];

const IDS = new Set<string>(BETA_FEATURES.map((f) => f.id));

export function isBetaFeature(value: unknown): value is BetaFeature {
  return typeof value === 'string' && IDS.has(value);
}

/** Opgeslagen waarde (JSON-tekst of lijst) → geldige id's, zonder dubbele. Onleesbaar = geen. */
export function parseBetaFeatures(value: unknown): BetaFeature[] {
  let list: unknown = value;
  if (typeof value === 'string') {
    try { list = JSON.parse(value); } catch { return []; }
  }
  if (!Array.isArray(list)) return [];
  return [...new Set(list.filter(isBetaFeature))];
}

/**
 * Mag dit bedrijf deze bètafunctie gebruiken? Alleen met GeoDesk én de schakelaar aan. Eén
 * regel voor backend, backoffice en veldapp, zodat ze het nooit oneens zijn.
 */
export function betaFeatureAllowed(
  company: { license?: string | null; betaFeatures?: unknown },
  feature: BetaFeature,
): boolean {
  return company.license === 'geodesk' && parseBetaFeatures(company.betaFeatures).includes(feature);
}
